import React, { useEffect, useRef, useState } from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { IoMenuSharp, IoCloseSharp } from 'react-icons/io5';
import { HiDocumentText } from 'react-icons/hi';
import { MdWork } from 'react-icons/md';
import { FaUser } from 'react-icons/fa';

import './Navbar.css';
import { headerData } from '../../data/headerData';

function Navbar() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [visible, setVisible] = useState(false);
    const lastScrollY = useRef(0);
    const navItems = [
        { to: '/#about', label: 'About', icon: <FaUser /> },
        { to: '/#education', label: 'Education', icon: <HiDocumentText /> },
        { to: '/#skills', label: 'Skills', icon: <HiDocumentText /> },
        { to: '/#experience', label: 'Work', icon: <MdWork /> },
        { to: '/#achievement', label: 'Awards', icon: <FaUser /> },
    ];

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY <= 24) {
                setScrolled(false);
                setVisible(true);
            } else {
                setScrolled(true);

                if (currentScrollY > lastScrollY.current && currentScrollY > 120) {
                    setVisible(false);
                } else {
                    setVisible(true);
                }
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const showNavbar = visible || mobileOpen;

    return (
        <div className={`navbar ${scrolled ? 'navbar-scrolled' : ''} ${showNavbar ? '' : 'navbar-hidden'}`}>
            <div className='navbar--container'>
                <div className='navbar-topbar'>
                    <NavLink
                        to='/#home'
                        smooth={true}
                        spy='true'
                        duration={2000}
                        className='navbar-brand-link'
                        onClick={() => setMobileOpen(false)}
                    >
                        <div className='navbar-brand'>
                            <div className='navbar-brand-mark'>AM</div>
                            <div>
                                <span className='navbar-brand-name'>{headerData.name}</span>
                                <p className='navbar-brand-subtitle'>{headerData.title}</p>
                            </div>
                        </div>
                    </NavLink>

                    <button
                        type='button'
                        className='navbar-mobile-toggle'
                        aria-expanded={mobileOpen}
                        aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
                        onClick={() => setMobileOpen((prev) => !prev)}
                    >
                        {mobileOpen ? <IoCloseSharp /> : <IoMenuSharp />}
                    </button>
                </div>

                <div className={`navbar-links ${mobileOpen ? 'navbar-links-open' : ''} ${scrolled ? 'navbar-links-scrolled' : ''}`}>
                    {navItems.map((item) => (
                        <NavLink
                            key={item.label}
                            to={item.to}
                            smooth={true}
                            spy='true'
                            duration={2000}
                            className='navbar-link'
                            activeClassName='navbar-link-active'
                            onClick={() => setMobileOpen(false)}
                        >
                            <span className='navbar-link-icon'>{item.icon}</span>
                            <span>{item.label}</span>
                        </NavLink>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Navbar;
